/**
 * AVA Design System — MonoText
 *
 * Wrapper para IDs, request UUIDs, timestamps y otros valores numéricos
 * que deben renderizarse con JetBrains Mono + tabular-nums para
 * alineación vertical correcta (audit logs, listados densos en compliance).
 *
 * Aplica la clase utilitaria .ava-mono del design system.
 */
import type { ReactNode, ElementType } from "react";

interface MonoTextProps {
  children: ReactNode;
  className?: string;
  /** Elemento HTML a renderizar. Default 'span'. Para bloques, usar 'div' o 'p'. */
  as?: ElementType;
}

export function MonoText({ children, className, as }: MonoTextProps) {
  const Component = (as ?? "span") as ElementType;
  return (
    <Component className={`ava-mono ${className ?? ""}`}>{children}</Component>
  );
}
